import { useEffect } from 'react';
import { LandingNav, Hero } from '@/components/landing/Hero';
import { HowItWorks, StylesShowcase, Features } from '@/components/landing/Sections';
import { Discover } from '@/components/landing/Discover';
import { MobileApps, Faq, LandingFooter, Pricing } from '@/components/landing/Bottom';
import { GlobalPlayer } from '@/components/player/GlobalPlayer';

export default function Landing() {
  useEffect(() => {
    document.title = 'MyMusic IA — Le studio de ton imagination | Crée ta musique avec l’IA';
  }, []);
  return (
    <div className="min-h-screen bg-black text-white" data-testid="landing-page">
      <LandingNav />
      <main>
        <Hero />
        <HowItWorks />
        <StylesShowcase />
        <Features />
        <Discover />
        <Pricing />
        <MobileApps />
        <Faq />
      </main>
      <LandingFooter />
      <GlobalPlayer />
    </div>
  );
}
